import XEUtils from "xe-utils";

/**
 * 自定义方法集合
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */

const str_num_add = (str_num,num)=>{
  var index = 0; 
  str_num = String(str_num);
  num = isNaN(num) ? 0 : num;
  for(let i = 0;i<str_num.length;i++){
    if(!/^\d+$/.test(str_num[i])) index = i+1
  }
  if(index){
    let str = str_num.slice(0,index)
    let number = str_num.slice(index,str_num.length)
    let r = (Number(number)+Number(num))
    return r < 0 ? str_num : (str + r)
  }else{
    let r = Number(str_num) + Number(num)
    return r < 0 ? str_num : r
  }
}
const filterCategory =  (val) => {
  const arr = val.filter(t=>t.status===1).map(v => {
    return {value: v.itemName, id: v.id}
  })
  return arr;
}
const filterMsgType =  (val) => {
  const arr = val.map(v => {
    return {value: v.itemValue, label: v.itemDesc}
  })
  return arr;
}
const pageAuth = (that, authFlag, routeName)=>{
  const name=routeName||that.$route.name;
  const key=name + '.' + authFlag;
  let menuObj = JSON.parse(sessionStorage.getItem('btn_auth')||'{}');
  return menuObj[key]||false;
}
const formatTime = (value, format) => {
  if(!value) return "";
  return XEUtils.toDateString(value, format);

}
const date = new Date();
let y = date.getFullYear() //年
let m = date.getMonth() + 1 //月
let d = date.getDate() //日
m = m < 10 ? '0' + m : m //月份补 0
d = d < 10 ? '0' + d : d //日数补 0

//中国标准时间转为为 yy-mm-dd
const farmatT = time=>{
  let date = new Date(time);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
   d = d < 10 ? ('0' + d) : d;
  // let h = date.getHours();
  // let minute = date.getMinutes();
  // minute = minute < 10 ? ('0' + minute) : minute;
  return y + '-' + m + '-' + d
}
//获取当月最后一日
function monthLast(y, m){
  let lastD = new Date(y, m, 0).getDate()
  return [y, m, lastD].join("-")
}
 // 本周最后一天
 function weekLast(){
  let week = date.getDay() //星期
  if (week === 0) {
    week = 7
  }
  var weekFirstDay = new Date(date - (week - 1) * 86400000)
  var weekLastDay = new Date((weekFirstDay / 1000 + 6 * 86400) * 1000)
  return farmatT(weekLastDay)
}

// 过滤从excel等文档中复制出来的特殊字符
function filterSpecialChars(str) {
  if (!str || typeof str !== 'string') return str
  const reg = /[\u000B]/g
  return str.replace(reg, '')
}

export default {
  $str_num_add: str_num_add,
  filterCategory: filterCategory,
  filterMsgType: filterMsgType,
  $auth: pageAuth,
  $formatTime: formatTime,
  $monthLast: monthLast,
  $weekLast: weekLast,
  $filterSpecialChars: filterSpecialChars,
}